/**
 * Перенос колонки в другой блок таблицы.
 *
 * Живёт отдельной функцией, а не внутри экрана: переносят колонку из трёх
 * мест — меню «Колонки», настроек колонки и перетаскиванием прямо в шапке,
 * и везде это одно и то же действие с одним и тем же сообщением об ошибке.
 */
import { api } from '../../../lib/api.js'
import { useApp } from '../../../store/app-store.js'
import { tableTexts as t } from '../texts.table.js'

export async function moveColumnToGroup(code: string, group: string): Promise<void> {
  const { reloadBootstrap, toast } = useApp.getState()
  try {
    await api.renameTableTitle({ kind: 'move', code, title: group })
    await reloadBootstrap()
  } catch (err) {
    toast('error', err instanceof Error ? err.message : t.columnSettings.failed)
  }
}
